<div
  class="d-inline-flex align-items-start flex-column input-text-sizing"
  [formGroup]="parentFormGroup"
>
  <div class="field-label">
    {{ label + asterisk }}
  </div>
  <mat-form-field
    class="editor inline-editable-editor"
    floatLabel="auto"
    [hideRequiredMarker]="true"
    attr.aria-label="{{ label }}"
  >
    <input
      matInput
      [id]="formElementId"
      [formControlName]="formElementId"
      [matDatepicker]="datePicker"
      [matDatepickerFilter]="dateFilter"
      placeholder="DD/MM/YYYY"
      tabIndex="0"
    />
    <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
    <mat-datepicker #datePicker></mat-datepicker>
    <mat-error
      *ngIf="control.invalid && (control.dirty || control.touched)"
      class="invalid-feedback"
    >
      <div *ngIf="control.errors?.['matDatepickerParse']">
        Invalid date format
      </div>
      <div *ngIf="control.errors?.['matDatepickerFilter']">
        Future date is not allowed.
      </div>
      <div *ngIf="control.errors?.['required']">
        {{ errorLabel }} is required.
      </div>
    </mat-error>
  </mat-form-field>
</div>
